export function getItemCosts(job, dateRange) {
    let { getItemCostsRequest, getItemCostsError, getItemCostsResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_item_costs',
        this.createBundle('get_item_costs', { job, dateRange }, this.GET, getItemCostsRequest, getItemCostsResult, getItemCostsError)
    )
}
